jQuery(document).ready(function () {
    jQuery('.wm-imageCarousel__carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        prevArrow: jQuery('.wm-imageCarousel__arrow.slick-prev'),
        nextArrow: jQuery('.wm-imageCarousel__arrow.slick-next'),
        appendDots: '.wm-imageCarousel__dots',
    });
});
